module.exports = __webpack_public_path__ + "img/isoo.eb7f4f3a.jpeg";